module.exports = __webpack_public_path__ + "static/media/home_full_web.1e67cbc2.png";